import React from 'react';
import { GitBranch, Activity } from 'lucide-react';

export interface TriggerItem {
  id: string;
  name: string;
  description: string;
  icon: React.ComponentType<{ className?: string }>;
  iconColor: string;
  bgColor: string;
  enabled: boolean;
}

export const TRIGGERS: TriggerItem[] = [
  {
    id: 'attribute-segment',
    name: 'Segment change',
    description: 'A person enters or leaves a specific segment.',
    icon: GitBranch,
    iconColor: 'text-primary',
    bgColor: 'bg-primary/10',
    enabled: true,
  },
  {
    id: 'event',
    name: 'Event',
    description: 'A person performs an event in your product.',
    icon: Activity,
    iconColor: 'text-chart-7',
    bgColor: 'bg-chart-7/10',
    enabled: true,
  },
];
